export default __webpack_public_path__ + "static/media/circle-arrow-right-curved.a3025381.svg";